import { gql } from "@apollo/client";

import { OUTLET_FIELDS } from "@/graphql/queries/getOutlet";

export const CREATE_OUTLET_MUTATION = gql`
  mutation CreateOutlet($outlet: OutletAttributes!) {
    createOutlet(input: $outlet) {
      ...OutletFields
    }
  }
  ${OUTLET_FIELDS}
`;
